module.exports = __webpack_public_path__ + "static/img/stephenson-harwood.39f09d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/testimonial-logos/stephenson-harwood.png
// module id = xf5W
// module chunks = 0